import BASE_RULE from '../baseRule';
import {
	SearchTypeFileAspect,
	FileAspectType,
	FileAspectSubType,
	FileAspectOrientationValue,
} from './constants';
import {FileAspectRule} from './types';

export const fileAspectRuleDefaults: FileAspectRule = {
	...BASE_RULE,
	elementType: SearchTypeFileAspect,
	elementSubType1: FileAspectType.ORIENTATION,
	elementSubType2: FileAspectSubType.EQUAL_TO,
	elementValue1: FileAspectOrientationValue.LANDSCAPE,
};

export default fileAspectRuleDefaults;
